import Count1 from './count/1.svg';
import Count2 from './count/2.svg';
import Count3 from './count/3.svg';
import svg3 from './count/3.svg';
import UPDATE_CAPA1 from './update/Update1.png';
import UPDATE_CAPA2 from './update/Update2.png';
import UPDATE_CAPA3 from './update/Update3.png';
import UPDATE_CAPA4 from './update/Update4.png';
import UPDATE_CAPA5 from './update/Update5.png';

export default {
  Update: {
    UPDATE_CAPA1,
    UPDATE_CAPA2,
    UPDATE_CAPA3,
    UPDATE_CAPA4,
    UPDATE_CAPA5
  },
  Count: {
    Count1,
    Count2,
    Count3,
    svg3
  }
};
